import { NonConversionReason } from '../non-conversion';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_NON_CONVERSION_REASON = 'NON_CONVERSION_REASON_';

/** Libellés du sélecteur « Raison de non-conversion » de la fiche admin. */
export const NonConversionReasonTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.PRICE}`]: 'Trop cher',
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.NO_TIME}`]: 'Pas eu le temps de s’y mettre',
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.NOT_NEEDED}`]: 'N’en voit pas l’utilité',
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.ALREADY_EQUIPPED}`]:
      'Garde son outil actuel ou un concurrent',
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.MISSING_FEATURE}`]:
      'Il manque une fonctionnalité indispensable',
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.TECHNICAL_ISSUE}`]: 'Problème technique',
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.TOO_COMPLEX}`]: 'N’a pas compris comment faire',
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.BUSINESS_STOPPED}`]: 'Activité arrêtée ou en pause',
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.UNREACHABLE}`]: 'Injoignable',
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.OTHER}`]: 'Autre (voir la note)',
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.BLOCKED_ON_STEP}`]:
      'Resté bloqué sur une étape précise',
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.EXPECTATION_MISMATCH}`]:
      'Le produit ne fait pas ce qu’il croyait',
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.NOT_ENOUGH_CUSTOMERS}`]:
      'Pas assez de clients pour que ça vaille le coup',
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.NO_INTENT}`]:
      'N’a jamais vraiment eu l’intention d’essayer',
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.PREVIEW_DISLIKED}`]:
      'Le site ou l’aperçu ne lui plaisait pas',
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.NOT_AWARE}`]: 'N’a rien reçu, n’était pas au courant',
    [`${TRANSLATE_KEY_NON_CONVERSION_REASON}${NonConversionReason.REPEATED_POSTPONE}`]: 'Reports répétés sans échange',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  NonConversionReason,
  NonConversionReasonTranslation,
  TRANSLATE_KEY_NON_CONVERSION_REASON,
  true,
);
